import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import LightGrayBgWrapper from "../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import { useNavigate } from "react-router-dom"
import DynamicDropdown from "../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"

const AddNewShippingCarrier = () => {
  const navigate = useNavigate()

  const dropdownOptions = [
    { label: "Active", action: () => console.log("active") },
    { label: "Inactive", action: () => console.log("active") },
  ]

  return (
    <LightGrayBgWrapper>
      <div className="bg-white shadow px-4 p-3">
        <div className="d-flex justify-content-center">
          <div className="fw-semibold fs-5">Add New Shipping Carrier</div>
        </div>

        <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <Row className="row-cols-1 row-cols-md-2">
            <Col>
              <Row className="g-0">
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="carrierName">
                      Carrier Name
                    </Label>
                    <Input id="carrierName" name="carrierName" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="coverageAreas">
                      Coverage Areas
                    </Label>
                    <Input id="coverageAreas" name="coverageAreas" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label className="fw-medium" for="status">
                      Status
                    </Label>
                    <DynamicDropdown options={dropdownOptions} />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row className="g-0">
                <Col xs="12">
                  <FormGroup>
                    <Label className="fw-medium" for="serviceType">
                      Service Type
                    </Label>
                    <Input id="serviceType" name="serviceType" placeholder="" type="text" />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <div className="fw-medium mb-2">Contact Information</div>
                  <FormGroup>
                    <Row className="g-0">
                      <Col xs="2">
                        <Label className="fw-medium text-nowrap" for="phoneNumber">
                          Phone Number
                        </Label>
                      </Col>
                      <Col>
                        <Input id="phoneNumber" name="phoneNumber" placeholder="" type="text" />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row className="g-0">
                      <Col xs="2">
                        <Label className="fw-medium text-nowrap" for="email">
                          Email Address
                        </Label>
                      </Col>
                      <Col>
                        <Input id="email" name="email" placeholder="" type="email" />
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup>
                    <Row className="g-0">
                      <Col xs="2">
                        <Label className="fw-medium text-nowrap" for="websiteUrl">
                          Website URL
                        </Label>
                      </Col>
                      <Col>
                        <Input id="websiteUrl" name="websiteUrl" placeholder="" type="url" />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="d-flex justify-content-center gap-3 my-3">
            <DynamicButton theme="blue">Save</DynamicButton>
            <DynamicButton theme="blue-outline" onClick={() => navigate(-1)}>
              Cancel
            </DynamicButton>
          </div>
        </Form>
      </div>
    </LightGrayBgWrapper>
  )
}

export default AddNewShippingCarrier
